import { createContext, useContext, useEffect, useState } from "react";
import { trackAddToCart } from "@/lib/analytics";

const CartContext = createContext(null);
const KEY = "sole_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, quantity = 1, color = null) => {
    trackAddToCart(product, size, quantity, color);
    setItems((prev) => {
      const existing = prev.find(
        (i) => i.product_id === product.id && i.size === size && (i.color || null) === (color || null),
      );
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id && i.size === size && (i.color || null) === (color || null)
            ? { ...i, quantity: i.quantity + quantity }
            : i,
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          size,
          color,
          quantity,
        },
      ];
    });
    setOpen(true);
  };

  const updateQty = (product_id, size, color, quantity) => {
    if (quantity <= 0) return removeItem(product_id, size, color);
    setItems((prev) =>
      prev.map((i) =>
        i.product_id === product_id && i.size === size && (i.color || null) === (color || null)
          ? { ...i, quantity }
          : i,
      ),
    );
  };

  const removeItem = (product_id, size, color) => {
    setItems((prev) =>
      prev.filter(
        (i) => !(i.product_id === product_id && i.size === size && (i.color || null) === (color || null)),
      ),
    );
  };

  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
